import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { USRemoveConsentStep } from "./withdrawConsent/USRemoveConsentStep";
import { NotifyConsumer } from "./shared/NotifyConsumer";
import { VerifyConsumer } from "./shared/VerifyConsumer";

type Props = {
  request: DataRequestDetail;
};

export const RequestToWithdrawUSConsentSteps = ({ request }: Props) => {
  switch (request.state) {
    case "VERIFY_CONSUMER":
      return <VerifyConsumer />;
    case "REMOVE_CONSENT":
      return <USRemoveConsentStep />;
    case "NOTIFY_CONSUMER":
      return <NotifyConsumer />;
  }
  return null;
};
